/*SYSTEM IMPORTS*/
import React from 'react'

import './style'
import './media'

import Img from "components/Img";

/*Ui*/
import Cont from 'components/ui/Cont'
import MapClinic, { MapClinicMarker } from 'components/ui/MapClinic'
import Clinic from 'components/ui/Clinic'
// import ActionWrapp from 'components/ui/ActionWrapp'
import {Address} from 'components/ui/City'
import Specialty, { SpecialtyItem } from 'components/ui/Specialty'

import {IsArray, IsIsset, IsObject} from "helpers/ValueTests";

import {Helpers, Request} from "api";
import ClinicApi from "api/clinic";
import ConnectReduxWith from "helpers/Redux/connectRedux";


@ConnectReduxWith("settings")
class ContClinic extends React.PureComponent{
    state = { loading: true, data: {} }

    componentDidMount(){
        const { value = {} } = this.props
        const { clinic } = value

        if(IsIsset(clinic)){
            this.getClinicData(parseInt(clinic))
        }
    }

    getClinicData = async (id) => {
        const { settings = {} } = this.props

        const {lang = "ru"} = settings

        const resp = await Request(ClinicApi.ClinicGetById, {id, lang})

        this.setState({
            loading:false,
            data: resp
        });
    }

    render() {
        const { id, settings = {}, value } = this.props
        const { data = {}, loading = false } = this.state
        const {
            preview = "",
            title = "",
            map_lat = "",
            map_lng = "",
            address = "",
            scope = [],
            isset_preview = false,
        } = data

        if( loading ) return null;

        const { dictionary = {} } = settings
        const { basic_topics = [] } = dictionary

        let image = preview
        let isset_image = isset_preview

        if(IsArray(value.image) && value.image.length > 0){
            image = Helpers.GetImage( value.image[0], "full" )
            isset_image = true
        }

        return (
            <Cont id={`block-${id}`} className="cont-clinic">
                <div className="clinic__flex-wrapp">
                    <Clinic
                        name={title}
                        isset_preview={isset_image}
                        image={
                            <Img src={image} externals div/>
                        }
                    >
                        { scope.length > 0 &&
                            <Specialty>
                                {scope.map((item, index) => {
                                    let title = basic_topics.find( topic => topic.id == item)

                                    if( IsObject(title) && title.label) {
                                        return(
                                            <SpecialtyItem
                                                key={index}
                                                value={title.label}
                                            />
                                        )
                                    }
                                })}
                            </Specialty>
                        }

                        <Address value={address}/>
                    </Clinic>

                    <MapClinic
                        name={title}
                        lng={map_lng}
                        lat={map_lat}
                    />
                </div>
            </Cont>
        );
    }
}

export default ContClinic